import { render, staticRenderFns } from "./ViewFunctionTest.vue?vue&type=template&id=6b84c291&scoped=true&"
import script from "./ViewFunctionTest.vue?vue&type=script&lang=js&"
export * from "./ViewFunctionTest.vue?vue&type=script&lang=js&"
import style0 from "./ViewFunctionTest.vue?vue&type=style&index=0&id=6b84c291&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b84c291",
  null
  
)

export default component.exports